import { connect } from 'react-redux';
import NavigationMenu from './navigation-menu.component';

const mapStateToProps = ({}) => ({});

export default connect(mapStateToProps)(NavigationMenu);
